<div class="main">
    <br>
    <h2>Match Management</h2>
    <br>
    <div class="table-body">

        <!--lambda message-->
        <app-response-text
            [lambdaMessage]="lambdaMessage"
            [lambdaError]="lambdaError">
        </app-response-text>

        <app-data-grid
        [(data)]="matchList"
        (itemChange)="addRegexPair($event);"
        (buttonEvent)="lambdaMessage=''; lambdaError=false; handleButtonEvent($event);"
        [viewTemplate]="view"
        [formTemplate]="formView"
        [columnNames]="['Match Name', 'Match Pattern', 'Last Updated', 'Updated By']"
        [spacing]="[15, 22, 19, 15, 10]" 
        [itemsPerPage]="5"
        [objectBluePrint]="bluePrint"
        [allowDelete]="false"
        [(isValid)]="formValid"
        >

        <ng-template #view let-item>
            <td>{{item.Key}}</td>
            <td>{{item.data.matchPattern}}</td>
            <td>{{item.data.lastUpdated}}</td>
            <td>{{item.data.updatedBy}}</td>
        </ng-template>

        <ng-template #formView let-item>
            <td><input type="text" [disabled]="editRow" [(ngModel)]="item.Key" (ngModelChange)="formValid = validate(item);"></td>
            <td><input type="text" [(ngModel)]="item.data.matchPattern" (ngModelChange)="formValid = validate(item);"></td>
            <td>{{item.data.lastUpdated}}</td>
            <td>{{item.data.updatedBy}}</td>
        </ng-template>
    
    </app-data-grid>
    </div>

    <div class="test-body">
        <textarea [(ngModel)]="inputString" (ngModelChange)="lambdaError=false; lambdaMessage='';" class="input-text" placeholder="Input text"></textarea>
        <div class="test-panel">
            <select [(ngModel)]="matchKey">
                <option hidden selected>Select RegEx</option>
                <option *ngFor="let match of matchList;" [value]="match.Key">{{match.Key}}</option>
            </select>
            <br>
            <button (click)="callMatchingLambda();">Match</button>
        </div>
        <div *ngIf="output==true" class="match result"><mat-icon>check_circle_outline</mat-icon> Matched!</div>
        <div *ngIf="output==false" class="no-match result"><mat-icon>cancel</mat-icon> No Match.</div>
        <div *ngIf="output=='n/a'" class="not-set result"><mat-icon>radio_button_unchecked</mat-icon>No Result</div>

    </div>

</div>
<br>
